import { config } from '@/pageConfig/home/fr/en';
import { HomePageTemplate } from '@/pageTemplate/HomePageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';

export default function HomePage() {
  const { trackEvent, trackDataForGtm } = useAnalyticsContext();
  // biome-ignore lint/correctness/useExhaustiveDependencies: we want to track event only once
  useEffect(() => {
    trackEvent('home_page.viewed');
    trackDataForGtm('homepage_viewed');
  }, []);

  return <HomePageTemplate config={config} />;
}
